module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_a-function.js
// module id = ../../../../core-js/modules/_a-function.js
// module chunks = 0